import React from "react";
import { useTinyHost } from "@tiny/host-contract";
import { useSegmentsStatistics } from "./useSegmentsStatistics";

function useCustomSegmentFeatures() {
  const { capabilities, upsell } = useTinyHost();

  const { totalCustom } = useSegmentsStatistics();

  const FEATURE_SYSTEM_NAME = "CUSTOM_SEGMENTS";

  const details = React.useMemo(
    () => capabilities.featureDetails(FEATURE_SYSTEM_NAME),
    [capabilities]
  );

  const showUpgradePopup = React.useCallback(() => {
    const { enabled, featureCount } = details || {};
    const overLimit =
      enabled &&
      featureCount !== -1 &&
      (totalCustom || 0) >= (featureCount || 0);
    upsell.showFeatureUpgrade({
      featureName:
        capabilities.featureDetails(FEATURE_SYSTEM_NAME)?.name ||
        FEATURE_SYSTEM_NAME,
      message: overLimit
        ? "Your plan does not include this feature. Please upgrade to use."
        : undefined,
    });
  }, [capabilities, details, totalCustom, upsell]);

  const hasRightsToAccess = React.useCallback(
    (byLimit = false): boolean => {
      return capabilities.isFeatureEnabled(
        FEATURE_SYSTEM_NAME,
        byLimit ? totalCustom : undefined
      );
    },
    [capabilities, totalCustom]
  );

  return {
    details,
    isFeaturesLoading: capabilities.featuresLoading,
    hasRightsToAccess,
    showUpgradePopup,
  };
}

export default useCustomSegmentFeatures;
